import { createAction } from '@'
import axios from 'axios'
import { message, notification } from 'antd'
import { getAuth } from '@misc'

const ENDPOINT = process.env.REACT_APP_API_URL
const MAX_LISTED_IDS = 50

const describe = (body, fallback) => {
    const text = body.message || fallback
    const { conflict } = body
    if (!conflict || !conflict.column) {
        return text
    }
    return `${text} (${conflict.column} = ${conflict.value} is already used by hotel ${conflict.hotel_id})`
}

export const cacheNote = cache => (cache ? `cache flushed: ${cache.deleted_total || 0} keys` : 'cache not reported')

// Hotels without a hotel_mapping_provider row are skipped by the server because search cannot join them.
export const notifyWrite = (text, data) => {
    const title = `${text} · ${cacheNote(data.cache)}`
    const skipped = data.skipped_no_provider || []
    if (!skipped.length) {
        message.success(title, 5)
        return
    }
    const listed = skipped.slice(0, MAX_LISTED_IDS).join(', ')
    const more = skipped.length > MAX_LISTED_IDS ? ` and ${skipped.length - MAX_LISTED_IDS} more` : ''
    notification.warning({
        message: title,
        description: `${skipped.length} hotel(s) skipped, no hotel_mapping_provider row so search cannot use them: ${listed}${more}`,
        duration: 0
    })
}

export default createAction('FetchMappingCoverage', async ({ path, ...options }, config = {}) => {
    try {
        const { data } = await axios({
            url: `${ENDPOINT}/hotel/mapping-coverage${path}`,
            headers: { 'Content-Type': 'application/json', ...getAuth() },
            ...options
        })
        return data
    } catch (e) {
        const body = e.response && e.response.data && typeof e.response.data === 'object' ? e.response.data : {}
        const error = new Error(describe(body, e.message))
        error.status = e.response && e.response.status
        error.data = { ...body, success: false, message: error.message, status: error.status }
        if (!config.silent) {
            message.error(error.message, 15)
        }
        throw error
    }
})
